import moment from 'moment-timezone';

export const formatDate = (inpDate) => {
    let convertedDate = new Date(inpDate);
    let month = convertedDate.getMonth() + 1;
    let day = convertedDate.getDate();
    let year = convertedDate.getFullYear();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    let shortDate = `${day}-${month}-${year} 00:00:00`;

    return shortDate;
};

export const formatDateTime = (inpDate) => {
    let convertedDate = new Date(inpDate);
    let month = convertedDate.getMonth() + 1;
    let day = convertedDate.getDate();
    let year = convertedDate.getFullYear();
    let hour = convertedDate.getHours();
    let minute = convertedDate.getMinutes();
    let seconds = convertedDate.getSeconds();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    let shortDate = `${day}-${month}-${year} ${hour}:${minute}:${seconds}`;

    return shortDate;
};

export const isAdminRole = role => {
    if (role === 'EntAdmin' || role === 'SysAdmin' || role === 'HqAdmin') {
        return true
    }
    return false
}

export const isEntAdmin = role => {
    if (role === 'EntAdmin') {
        return true
    }
    return false
}

export const isSupportUser = role => {
    if (role === 'SupportUser') {
        return true
    }
    return false
}

export const isMessageAdminRole = role => {
    if (role === 'MessageAdmin') {
        return true
    }
    return false
}


export const isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0;
};

export const statusOptions = [
    { name: 'Active', code: 'Active' },
    { name: 'Inactive', code: 'Inactive' },
];

export const yesNoOptions = [
    { name: 'Yes', code: 'Y' },
    { name: 'No', code: 'N' },
]

export const authTypeOptions = [
    { name: 'Password', code: 'password' },
    { name: 'SSO', code: 'sso' },
]


export const actionTypeOptions = [
    // { name: 'User', code: 'user' },
    { name: 'Site', code: 'site' },
    { name: 'Site All', code: 'site-all' },
    { name: 'Site Group', code: 'site-group' },
];


export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};

export const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
};

export const completionOptions = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' },
];

export const recurrenceOptions = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' }
];

export const dateTimeFormat = 'DD-MM-YYYY HH:mm:ss';


export const timeZonesOptions = moment.tz.names().map((tz) => {
    const offset = moment.tz(tz).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";
    const formattedOffset = `UTC${offset === 0 ? "" : `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`}`;

    return { name: tz, code: formattedOffset };
});



export const selectedTimeZoneTemplate = (option, props) => {
    if (option) {
        return (
            <div className="flex align-items-center gap-10">
                <div>{option.name} - {option.code}</div>
            </div>
        );
    }

    return <span>{props.placeholder}</span>;
};

export const timeZoneOptionTemplate = (option) => {
    return (
        <div className="flex align-items-center gap-10">
            <div>{option.name} - {option.code}</div>
        </div>
    );
};

const convertToTimezone = (utcDateTime, timeZone, format) => {
    if (utcDateTime) { 

    }
    return moment.utc(utcDateTime, "DD-MM-YYYY HH:mm:ss").tz(timeZone).format(format);
};

export const dateTimeTemplate = utcDateTime => {
    if (!utcDateTime) { 
        return utcDateTime;
    }
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return convertToTimezone(utcDateTime, browserTimezone, "DD-MM-YYYY HH:mm:ss")
}

export const dateTemplate = utcDate => {
    if (!utcDate) { 
        return utcDate;
    }
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return convertToTimezone(utcDate, browserTimezone, "DD-MM-YYYY")
}

export const timeTemplate = utcTime => {
     if (!utcTime) { 
        return utcTime;
    }
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return convertToTimezone(utcTime, browserTimezone, "HH:mm:ss")
}
